// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0

/* eslint-disable */

// Amazon IVS Playback URL
// Replace this with your own Amazon IVS Playback URL
export const PLAYBACK_URL_TEST =
  "https://fcc3ddae59ed.us-west-2.playback.live-video.net/api/video/v1/us-west-2.893648527354.channel.DmumNckWFTqz.m3u8";
export const PLAYBACK_URL =
  "https://35d97ad19b1f.ap-northeast-2.playback.live-video.net/api/video/v1/ap-northeast-2.788087404574.channel.awuXp7gv7bS2.m3u8";

// Chat websocket address
// The AWS region that your room is created in. For example, `us-west-2`.
export const CHAT_REGION = "ap-northeast-2";

// Chat API URL
// The Amazon IVS Chat backend endpoint. You must deploy the serverless backend to get this value.
export const API_URL =
  "https://g4gyt1g4k5.execute-api.ap-northeast-2.amazonaws.com/Prod/";
// export const API_URL = "http://localhost:3100/";

// Chat room id (ARN)
export const CHAT_ROOM_ID =
  "arn:aws:ivschat:ap-northeast-2:788087404574:room/2LAWyvWtBlhb";
